"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconLink = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M32.88 45l-.28.26a1.29 1.29 0 0 0-.47 1.08 1.19 1.19 0 0 1-.34 1l-7.36 7.36a1.2 1.2 0 0 1-1.69 0l-7.36-7.36a1.2 1.2 0 0 1 0-1.7l7.36-7.36a1.19 1.19 0 0 1 .85-.35A1 1 0 0 1 24 38a1 1 0 0 0 1.16-.21l.28-.3L29 33.85a7.64 7.64 0 0 0-4.12-2.18 7.54 7.54 0 0 0-6.63 2.1l-7.36 7.36a7.56 7.56 0 0 0 0 10.67l7.36 7.36a7.55 7.55 0 0 0 10.67 0l7.23-7.23a7.79 7.79 0 0 0 2.29-4.59 7.5 7.5 0 0 0-1.93-6zM59 18.08l-7.2-7.2A7.59 7.59 0 0 0 44.12 9a7.25 7.25 0 0 0-3 1.87l-7.37 7.37a7.26 7.26 0 0 0-1.87 3 7.6 7.6 0 0 0 1.87 7.63l.13.13 3.66-3.66.19-.17a1.12 1.12 0 0 0 .27-1.32.85.85 0 0 1-.1-.27 1.19 1.19 0 0 1 .35-.85l7.36-7.36a1.2 1.2 0 0 1 1.69 0l7.36 7.36a1.2 1.2 0 0 1 0 1.69l-7.36 7.36a1.19 1.19 0 0 1-.85.35h-.19a1 1 0 0 0-.91.37q-.16.19-.34.37l-3.64 3.64a7.5 7.5 0 0 0 6 1.93 7.79 7.79 0 0 0 4.59-2.29l7.23-7.23a7.5 7.5 0 0 0 2.21-5.54 7.85 7.85 0 0 0-2.4-5.3z"
  }), _react["default"].createElement("path", {
    d: "M26.9 43.48a3.17 3.17 0 0 0 4.49 0l12.1-12.1a3.17 3.17 0 1 0-4.49-4.5L26.9 39a3.17 3.17 0 0 0 0 4.48z"
  })),
  height: undefined,
  width: undefined
});
IconLink.displayName = 'IconLink';
var _default = IconLink;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/link.js
// module id = 578
// module chunks = 0